import React from 'react';
import PropTypes from 'prop-types';

import cityToggleConfig from '@common/config/cityToggleConfig';

import NoDepositBanner from '@search/components/NoDepositBanner';
import FreeCancellationBanner from '@search/components/FreeCancellationBanner';

const SearchBanner = ({ cityId, cancellationPolicies, moveIn }) => {
  if (cityToggleConfig(cityId).isNoDepositSupported) {
    return <NoDepositBanner />;
  }
  return (
    <FreeCancellationBanner
      moveIn={moveIn}
      cancellationPolicies={cancellationPolicies}
    />
  );
};

SearchBanner.propTypes = {
  cityId: PropTypes.string.isRequired,
  cancellationPolicies: PropTypes.shape({}),
  moveIn: PropTypes.string
};

SearchBanner.defaultProps = {
  cancellationPolicies: {},
  moveIn: null
};

export default SearchBanner;
